import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Instagram, Facebook, MapPin, Send, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received! We'll reply within 1-2 business days.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Try email instead.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="contact-page" className="max-w-6xl mx-auto px-5 py-16">
      <div className="mb-10">
        <div className="inline-block bg-[#F3E30A] text-[#000000] text-xs font-bold px-3 py-1 rounded-full mb-3 border-2 border-[#000000]">
          SAY HELLO
        </div>
        <h1 className="font-display font-black text-5xl md:text-7xl text-[#000000] leading-none">
          Let's build <br /> something bold.
        </h1>
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        <form onSubmit={submit} className="brutal-lg bg-white rounded-3xl p-6 md:p-8 space-y-4">
          <div data-testid="order-inquiry-note" className="bg-[#FFFBEA] border-2 border-black rounded-xl p-4 text-sm text-[#333]">
            <strong className="text-black">Have a question about your order?</strong> Please include your order
            number and the email address or phone number used when placing your order so we can better assist you.
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-[#000000] mb-1 block">Name</label>
            <input
              data-testid="contact-name"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full px-4 py-3 border-2 border-[#000000] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#EC008C]"
            />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-[#000000] mb-1 block">Email</label>
            <input
              data-testid="contact-email"
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full px-4 py-3 border-2 border-[#000000] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#EC008C]"
            />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-[#000000] mb-1 block">Message</label>
            <textarea
              data-testid="contact-message"
              required
              rows={5}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full px-4 py-3 border-2 border-[#000000] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#EC008C]"
            />
          </div>
          <button
            data-testid="contact-submit"
            disabled={loading}
            className="w-full bg-[#EC008C] text-[#FFFFFF] font-display font-bold text-lg py-4 rounded-full brutal-lg flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 size={20} className="animate-spin" /> : <><Send size={18} /> Send Message</>}
          </button>
        </form>

        <div className="space-y-4">
          <a href="mailto:hello@makebadesigns.com" className="block brutal bg-[#CCDE00] text-[#000000] rounded-3xl p-6">
            <Mail size={24} className="mb-3" />
            <div className="font-display font-black text-xl">hello@makebadesigns.com</div>
            <div className="text-sm opacity-90 mt-1">Email - replies in 1-2 business days</div>
          </a>
          <a href="https://instagram.com/makebadesigns" target="_blank" rel="noreferrer" className="block brutal bg-[#EC008C] text-[#FFFFFF] rounded-3xl p-6">
            <Instagram size={24} className="mb-3" />
            <div className="font-display font-black text-xl">@makebadesigns</div>
            <div className="text-sm opacity-90 mt-1">Instagram - behind the scenes</div>
          </a>
          <a href="https://facebook.com/makebadesigns" target="_blank" rel="noreferrer" className="block brutal bg-[#EC008C] text-[#FFFFFF] rounded-3xl p-6">
            <Facebook size={24} className="mb-3" />
            <div className="font-display font-black text-xl">@makebadesigns</div>
            <div className="text-sm opacity-90 mt-1">Facebook - updates &amp; releases</div>
          </a>
          <div className="brutal-static bg-[#F3E30A] rounded-3xl p-6">
            <MapPin size={24} className="mb-3 text-[#000000]" />
            <div className="font-display font-black text-xl text-[#000000]">Oklahoma City, Oklahoma</div>
            <div className="text-sm text-[#000000]/70 mt-1">Studio &amp; print shop</div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
